export default __webpack_public_path__ + "static/media/DIADYMA_L_WHITE.2a8abd65.png";